module.exports = __webpack_public_path__ + "img/2fb93d3.png";